'use strict';

var CalendarWeek = require('../../../../_virtual/CalendarWeek.js_commonjs-exports.js');
var interopRequireDefault = require('../../node_modules/@babel/runtime/helpers/interopRequireDefault.js');
var React = require('react');
var index = require('../../../airbnb-prop-types/index.js');
require('./CalendarDay.js');
require('./CustomizableCalendarDay.js');
var CalendarDay = require('../../../../_virtual/CalendarDay.js_commonjs-exports.js');
var CustomizableCalendarDay = require('../../../../_virtual/CustomizableCalendarDay.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

(function (exports) {

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CalendarWeek;

var _react = _interopRequireDefault(React__default["default"]);

var _airbnbPropTypes = index;

var _CalendarDay = _interopRequireDefault(CalendarDay.__exports);

var _CustomizableCalendarDay = _interopRequireDefault(CustomizableCalendarDay.__exports);

var propTypes = process.env.NODE_ENV !== "production" ? (0, _airbnbPropTypes.forbidExtraProps)({
  children: (0, _airbnbPropTypes.or)([(0, _airbnbPropTypes.childrenOfType)(_CalendarDay["default"]), (0, _airbnbPropTypes.childrenOfType)(_CustomizableCalendarDay["default"])]).isRequired
}) : {};

function CalendarWeek(_ref) {
  var children = _ref.children;
  return _react["default"].createElement("tr", null, children);
}

CalendarWeek.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
}(CalendarWeek.__exports));
